import loadApp from '../2loaders/index.js';
const app = loadApp();

export default app;
